module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fc-Gb-Hc-Ia.a6968dce.png";